import React from 'react';
import {FormHelperText, Grid} from '@material-ui/core';
import LinkBlockContainer from 'data/redux/containers/linkBlockContainer/LinkBlockContainer';
import {Form, Formik} from 'formik';
import * as Yup from "yup";
import styles from './SignInForm.module.scss';
import FormikPasswordInput from 'gui/components/formikPasswordInput/FormikPasswordInput';
import {linksMap} from 'data/utils/constants';
import FormikErrorScrollToTop from 'formik-top-error-focus';
import Recaptcha from 'gui/components/recaptcha/Recaptcha';
import NextButton from 'gui/components/nextButton/NextButton';
import FormErrorDisplay from 'gui/components/formErrorDisplay/FormErrorDisplay';
import FormikTextField from 'gui/components/formikTextField/FormikTextField';


interface ISignUpFormProps {
  onSubmit: (formValues) => Promise<any>;
  invalidLogin?: boolean;
  invalidRecaptcha?: boolean;
  loading?: boolean;
}

const yupSchema = Yup.object({
  email: Yup.string()
    .email("מייל לא תקין")
    .required("נדרש מייל"),
  password: Yup.string()
    .required('נדרשת סיסמה')
    .min(8, 'סיסמה קצרה מדיי, מינימום 8 אותיות או ספרות')
    .matches(/[a-zA-Z0-9]/, 'סיסמה יכולה רק להכיל אותיות באנגלית ומספרים'),
  recaptcha: Yup.string().min(1).required("יש לסמן וי לא רובוט"),
});

const SignInForm = ({loading, ...props}: ISignUpFormProps) => {
  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
        recaptcha: "",
        showPassword: false,
      }}
      validationSchema={yupSchema}
      onSubmit={async (values, {setSubmitting}) => {
        try {
          await props
            .onSubmit(values);
        } catch (e) {
          setSubmitting(false);
        }
      }}
      enableReinitialize={true}
    >
      {(form) => (
        <Form translate={null} className={styles.signInForm}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {props.invalidLogin ? <FormHelperText error>פרטי כניסה לא נכונים</FormHelperText> : null}
              {props.invalidRecaptcha ? <FormHelperText error>אימות רובוט נכשל</FormHelperText> : null}

            </Grid>
            <Grid item xs={12} style={{marginTop: 10}} sm={12}>
              <FormikTextField
                label="מייל"
                name="email"
                autoComplete="email"
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} style={{marginTop: 15}} sm={12}>
              <FormikPasswordInput
                label="סיסמה"
                name="password"
                loading={loading}
              />
            </Grid>
            <Grid item xs={6}/>
            <Grid item style={{marginTop: -5}} xs={6}>
              <LinkBlockContainer style={{color: '#05BEC0', marginTop: 0, padding: 0, fontSize: 14}}
                                  className="text-left text-capitalize" to={linksMap.forgotPassword}>
                שכחת סיסמה?
              </LinkBlockContainer>
            </Grid>
            <Grid item xs={12}>
              <Recaptcha loading={loading}
                         onVerify={verifyCode => {
                           form.setFieldValue('recaptcha', verifyCode, false)
                         }}/>
              <FormErrorDisplay className={styles.recaptchaError}
                                form={form}
                                field={{name: 'recaptcha', value: form.values.recaptcha}}/>
            </Grid>

            <Grid item xs={1}/>
            <Grid item style={{marginTop: 15}} xs={10}>
              <NextButton
                isDisabled={form.isSubmitting}
                onClick={form.submitForm}
                loading={loading}
              >
                התחברות
              </NextButton>
            </Grid>
            <Grid item xs={1}/>
          </Grid>
          <Grid container justifyContent="flex-end">
            <Grid item>
            </Grid>
          </Grid>
          <FormikErrorScrollToTop/>
        </Form>
      )}
    </Formik>
  );
};

SignInForm.defaultProps = {
  onSubmit: (formValues) => new Promise((resolve) => {
    
    setTimeout(resolve, 1000);
  }),
  invalidLogin: false,

  loading: false,
};

export default React.memo(SignInForm);
